import type { GraphQLClient } from "graphql-request"
import { createContext, useContext } from "react"

export const GraphQLClientContext = createContext<GraphQLClient | undefined>(undefined)

export const useGraphQLClient = (): GraphQLClient => {
  const client = useContext(GraphQLClientContext)

  if (!client) {
    throw new Error("useGraphQLClient must be used inside an AppProviders tree")
  }

  return client
}
